import SEO from "@/components/SEO";
import { useAuth } from "@/contexts/AuthContext";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { useTestimonials } from "@/hooks/useTestimonials";
import { HeroSection } from "./home/HeroSection";
import { SocialProofSection } from "./home/SocialProofSection";
import { NumbersBandSection } from "./home/NumbersBandSection";
import { TestimonialsSection } from "./home/TestimonialsSection";
import { PricingSection } from "./home/PricingSection";
import { ProblemSection } from "./home/ProblemSection";
import { HowItWorksSection } from "./home/HowItWorksSection";
import { FeaturesSection } from "./home/FeaturesSection";
import { ScreenshotsSection } from "./home/ScreenshotsSection";
import { WhyLeaseFlowSection } from "./home/WhyLeaseFlowSection";
import { UseCasesSection } from "./home/UseCasesSection";
import { TrustSection } from "./home/TrustSection";
import { FinalCtaSection } from "./home/FinalCtaSection";

export default function Home() {
  const { user } = useAuth();
  const settings = useSiteSettings();
  const { items: testimonials } = useTestimonials();

  return (
    <div data-testid="page-home">
      <SEO
        title="LeaseFlow — Visual case management for UK conveyancing firms"
        description="Reduce client confusion, cut 'any update?' emails, share secure read-only case timelines. Built for UK conveyancing and leasehold law firms."
        path="/"
      />
      <HeroSection settings={settings} />
      <SocialProofSection />
      <NumbersBandSection />
      <TestimonialsSection testimonials={testimonials} />
      <PricingSection settings={settings} user={user} />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturesSection />
      <ScreenshotsSection />
      <WhyLeaseFlowSection />
      <UseCasesSection />
      <TrustSection />
      <FinalCtaSection />
    </div>
  );
}
